import { useQuery } from '@tanstack/react-query';
import { clubConditionsApi } from '../services/apiService';
import { TimePeriod } from '../types/api';
import { ClubConditionsResponse } from '../types/clubConditions';
import { logger } from '../utils/logger';

// Query keys for cache management
export const CLUB_CONDITIONS_CUSTOM_DASHBOARD_QUERY_KEYS = {
  CLUB_CONDITIONS_DATA: 'clubConditionsDataForCustomDashboard',
};

/**
 * Hook to fetch club conditions data for use in custom dashboard
 * This hook is specifically designed for club conditions components when used in the custom dashboard
 */
export function useClubConditionsDataForCustomDashboard(branchId: number | undefined, timeRange: TimePeriod | undefined) {
  return useQuery<ClubConditionsResponse>({
    queryKey: [CLUB_CONDITIONS_CUSTOM_DASHBOARD_QUERY_KEYS.CLUB_CONDITIONS_DATA, branchId, timeRange],
    queryFn: async () => {
      if (!branchId) throw new Error('Branch ID is required');
      
      try {
        const response = await clubConditionsApi.getClubConditionsData(branchId, timeRange);
        return response;
      } catch (error) {
        logger.error('Failed to fetch club conditions data for custom dashboard', 'ClubConditionsCustomDashboardQueries', error);
        throw error;
      }
    },
    enabled: !!branchId,
    staleTime: 5 * 60 * 1000, // 5 minutes
    retry: 2,
  });
}